import React, { useState, useEffect } from 'react'
import { bindActionCreators } from "redux";
import { returnType } from "../Utilities/ReturnType";
import { connect } from "react-redux";
import { GlobalAutoHealing } from "../Interface/IGlobalAutoHealing";
import { useSearchParams, useLocation } from 'react-router-dom'
import { Spinner, SpinnerSize } from 'office-ui-fabric-react'
import { getContentMarkerReview, getMakeasReviewed, getArchiveArticle, getImproveArticle, getReviewhistory } from "../../redux/Actions/PowerDataQuery";
import ArticleDiff from '../ArticleDiff/ArticleDiff';
import { RemediationUsers } from '../../ConfigData/RemediationUsers'
import { useNavigate } from "react-router-dom";
import { IHealingCompleteParams } from "../Interface/Params/IAutoHealingPayload"
import {  useMsal, useAccount } from "@azure/msal-react";
import ExceptionReportDialog from "../CustomDialog/ExceptionReportDialog/ExceptionReportDialog";
import { formatDateToUTCStringDate } from '../Utilities/CommonFunction';
import { getAPIService } from "../../redux/Actions/PowerDataQuery";
import { IContextualMenuProps,Checkbox ,Stack} from '@fluentui/react';
import CustomMessageAlert from "../CustomMessageAlert/CustomMessageAlert";
import { CommandButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';

import './ArchivingContentMarker.css'

const actionCreators = {
    getContentMarkerReview,
    getArchiveArticle, 
    getImproveArticle,
    getMakeasReviewed
};

type DispatchProps = typeof actionCreators;

const mapStateToProps = (state: GlobalAutoHealing) => ({
    apiResponseState: state.apiResponseState,
    reviewContentMarker: state.reviewContentMarker,
    replaceContent: state.replaceContent,
    radioSelected: state.radioSelected
});

const storeProps = returnType(mapStateToProps);
type StoreProps = typeof storeProps.returnType;

interface IMessageState {
    showMessage: boolean,
    messageType: string,
    message: string,
    onDismiss?: () => void
}

interface IScanIssueData {
    content?: string;
    context?: string;
    category?: string;
    status?: string;
}

interface IListItem {
    content: string;
    context: string;
    category?: string;
    status: string;
}

const apiService = getAPIService().issueCenterService; 

const rubikUrl = `${process.env.REACT_APP_RUBIK_API_URL}`;

/**
 * broken link checker
 * @param props 
 * @returns 
 */
function ArchivingContentMarker(props: StoreProps & DispatchProps) {
    const { accounts } = useMsal();
    const [search] = useSearchParams();
    const requesturl = search.get('url')
    const ticketID = search.get('ticketID')
    const curationID = search.get('curationID')
    const datamart = search.get('datamart')
    const jobID = search.get('jobID')
    const pathArr = useLocation().pathname.split('/')
    const userAccount = useAccount(accounts[0]);

    const history = useNavigate();

    // set the healing complete params
    let healingCompleteParams: IHealingCompleteParams = {
        reviewType: "",
        requesturl: requesturl,
        fixerPath: pathArr[pathArr.length-1],
        traceID: ticketID,
        curationID: curationID,
        archiveDays: "120",
        renewDays: "30",
        completeTitle: "Thank you!"
    }
    
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

    const [issueList, setIssueList] = useState<IScanIssueData[]>([])

    const [buttonStyle, setButtonStyle] = useState<boolean>(false)

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    // Ticket Management ObservableValue
    // const collapsedTicket = new ObservableValue<boolean>(false);

    const [showReport, setShowReport] = useState<boolean>(false)

    const [reportDetailCss, setReportDetailCss] = useState<string>('')

    const [reportType, setReportType] = useState<string>('')

    const [currentExecuteRow, setCurrentExecuteRow] = useState(null);

    const [tableItems, setTableItems] = useState<IScanIssueData[]>([])

    const [checkbox, setCheckbox] = useState<boolean>(false)

    /**
     * Tab bar related
     */
    const [tabGroupNames, setTabGroupNames] = useState<string[]>(['Content'])

    /** Initialize editor data state */
    const [newDiffEditorData, SetNewDiffEditorData] = useState<string>("");
    const [newNavigationDiffEditorData, SetNewNavigationDiffEditorData] = useState<string>("");
    const [newMetaDiffEditorData, SetNewMetaDiffEditorData] = useState<string>("");

    const [messageState, setMessageState] = useState<IMessageState>(() => {
        return {
            showMessage: false,
            messageType: '',
            message: '',
            onDismiss: null
        }
    })

    /**
     * Get the content from the api
     */
    useEffect(() => {

        // when the url is empty, show the error dialog
        if (!requesturl) {
            window.location.href = `https://aka.ms/ChironDocs`
            return
        }

        // Load data from API in effect
        const loadData = async () => {
            setIsLoading(true)

            getReviewhistory(requesturl, ticketID).then(async res => {
                if (res.Result != null && res.Result.ReviewResult == 5) {
                    setIsLoading(false);

                    healingCompleteParams.reviewType = 'MarkeAsReview'
                    healingCompleteParams.completeTitle = ""
                    history(`/apps/close`, { state: healingCompleteParams })
                    
                    return;
                }

                // call the api to get the content
                await props.getContentMarkerReview(requesturl, ticketID, curationID, datamart);

                const reviewContentMarker = props.reviewContentMarker
                // const allOrgList = [...reviewContent.ReplacementList, ...reviewContent.MetaReplacementList, ...reviewContent.NavReplacementList]
                const brokenLinks = []
                // allOrgList.forEach(item => {
                //     brokenLinks.push({
                //         content: item.BrokenLink,
                //         context: item.BrokenLinkText,
                //         category: '',
                //         status: 'Broken'
                //     })
                // })

                setIssueList(brokenLinks);
                setIsLoading(false);

            });
            
        }

        loadData();
    }, [requesturl, ticketID, curationID])

    /**
     * handle review content change
     */
    useEffect(() => {
        if (props.reviewContentMarker) {
            // // When no broken links are detected, redirect to the completion page.
            // if (props.reviewContentMarker?.AutoChangeSummaryHtml =="") {
            //     healingCompleteParams.reviewType = 'NoBrokenLink'
            //     healingCompleteParams.completeTitle = "Thank you!"
            //     history(`/apps/close`, { state: healingCompleteParams })
            // }

            // init tab
            const tabSet = new Set<string>()

            // if(props.reviewContent?.NavOriginalText) {
            //     tabSet.add('Navigation')
            //     SetNewNavigationDiffEditorData(props.reviewContent.NavChangedText)
            // }
            if(props.reviewContentMarker?.ArticleInfo?.Content?.ContentData) {
                tabSet.add('Content')
                SetNewDiffEditorData(props.reviewContentMarker?.ArticleInfo?.Content?.ContentData)
                SetNewNavigationDiffEditorData(props.reviewContentMarker?.ArticleInfo?.Content?.ContentData)
            }
            if(props.reviewContentMarker?.ArticleInfo?.Content?.MetaData) {
                tabSet.add('Metadata')
                SetNewMetaDiffEditorData(props.reviewContentMarker?.ArticleInfo?.Content?.MetaData)
            }

            setTabGroupNames(Array.from(tabSet))

            const reviewContentMarker = props.reviewContentMarker
            // const allOrgList = [...reviewContent.ReplacementList, ...reviewContent.MetaReplacementList, ...reviewContent.NavReplacementList]
            const brokenLinks = []
            // allOrgList.forEach(item => {
            //     brokenLinks.push({
            //         content: item.BrokenLink,
            //         context: item.BrokenLinkText,
            //         category: '',
            //         status: 'Broken'
            //     })
            // })
            setIssueList(brokenLinks)

            // // When the user fixes broken links through autohealing tool and the time for repair has not exceeded 30 minutes, redirect to the completion page.            
            // const approveUtcTime = props.reviewContent?.ReviewHistory?.ReviewDate;
            // const reviewResult = props.reviewContent.ReviewHistory?.ReviewResult;
            // if (approveUtcTime && (props.reviewContent.ReviewHistory?.ReviewResult === 3 || props.reviewContent.ReviewHistory?.ReviewResult === 4)) {
            //     const durationUtcTime = SubtractUtcTimes(approveUtcTime)
            //     if (durationUtcTime < 30) {
            //         healingCompleteParams.reviewType = 'NoBrokenLink'
            //         healingCompleteParams.completeTitle = "Thank you!"
            //         history(`/apps/close`, { state: healingCompleteParams })
            //     }
            // }

            // No permission to access the page
            if (!isRemediationUser()) {
                healingCompleteParams.reviewType = 'NoPermission'
                healingCompleteParams.completeTitle = "Thank you!"
                history(`/apps/close`, { state: healingCompleteParams })
            }

            // // Set the review result
            // if (reviewResult === 1) {
            //     FixRadioButton.value = "Exception";
            // }
            // else if (reviewResult === 2) {
            //     FixRadioButton.value = "ManuallyFix";
            // }
            // else if (reviewResult === 4) {
            //     FixRadioButton.value = "Replace";
            //     setShowReplaceButton(true);
            // }
            // else {
            //     FixRadioButton.value = "Approve";
            // }
        }
    }, [props.reviewContentMarker])

    function clickMakeasReviewed(rollback) {
        var data = {
            ticketGuid: ticketID,
            curationId: curationID,
            dataMart: datamart,
            rollback: rollback,
        }

        setIsSubmitting(true)
        getMakeasReviewed(data).then(res => {
            setIsSubmitting(false)

            if (res.Success) {
                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Congratulations, you have successfully attested.'
                })

                setTimeout(() => {
                    healingCompleteParams.reviewType = 'MarkeAsReview'
                    healingCompleteParams.completeTitle = ""
                    healingCompleteParams.archiveDays = props.reviewContentMarker?.TicketInfo?.ArchiveDays
                    healingCompleteParams.renewDays = props.reviewContentMarker?.TicketInfo?.RenewDays
                    healingCompleteParams.ticketID = ticketID
                    healingCompleteParams.curationID = curationID
                    healingCompleteParams.datamart = datamart
                    healingCompleteParams.jobID = jobID
                    healingCompleteParams.articleUrl = requesturl
                    history(`/apps/close`, { state: healingCompleteParams })
                }, 1500);
            } else {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `${res.ErrorMessage}`,
                    onDismiss: dismissAlert
                })
            }

            setTimeout(() => {
                dismissAlert();
            }, 3500);

        });
    }

    function clickImproveArticle() {
        var data = {
            ticketGuid: ticketID,
            curationId: curationID,
            dataMart: datamart,
        }

        setIsLoading(true)
        getImproveArticle(data).then(res => {
            setIsLoading(false)
            if (res.Success) {
                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Successfully reported!'
                })
    
                var url = rubikUrl + `/improve?AssetType=Article&AssetURL=${requesturl}`;
                window.location.href = url;
                // window.open(url, '_blank');
            } else {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `Report failed, detail:${res.ErrorMessage ? res.ErrorMessage : 'Unknown error, please try again later!'}`,
                    onDismiss: dismissAlert
                })
            }

            setTimeout(() => {
                dismissAlert();
            }, 2000);

        });

    }

    function clickArchiveArticle() {
        var data = {
            ticketGuid: ticketID,
            curationId: curationID,
            dataMart: datamart,
        }
        
        setIsLoading(true)
        getArchiveArticle(data).then(res => {
            setIsLoading(false)
            if (res.Success) {
                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Successfully reported!'
                })
    
                var url = rubikUrl + `/archive?AssetType=Article&AssetURL=${requesturl}&RedirectIt=No`
                window.location.href = url;
                // window.open(url, '_blank');
            } else {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `Report failed, detail:${res.ErrorMessage ? res.ErrorMessage : 'Unknown error, please try again later!'}`,
                    onDismiss: dismissAlert
                })
            }

            setTimeout(() => {
                dismissAlert();
            }, 2000);

        });
    }

    /**
     * check if the user is in the remediation user list
     * @returns 
     */
    function isRemediationUser() {
        let userExsit = RemediationUsers.find((userItem) => userItem.userName === userAccount.username)
        if (userAccount.username !== props.reviewContentMarker?.TicketInfo?.RequiredAlias &&
            userAccount.username !== props.reviewContentMarker?.TicketInfo?.OptionalAlias &&
            userAccount.username !== props.reviewContentMarker?.TicketInfo?.ManagerAlias &&
            !userExsit) {
            return false;
        }

        return true;
    }

    /**
     * Collapse or expand the Ticket Management
     */
    // function onCollapseTicketClicked() {
    //     collapsedTicket.value = !collapsedTicket.value;
    // };

    const onDismiss = () => {
        setIsDialogOpen(false)
    };
    
    const dismissReportDetail = () => {
        setReportDetailCss('report-detail-form-out')
        setTimeout(()=>{
            setShowReport(false)
        },500)
    }

    const dismissAlert = () => {
        setMessageState({
            messageType: '',
            showMessage: false,
            message: ''
        })
    }

    const submitReportDetail = async(exceptionType: string,businessJustificationValue: string,expirationDate: string) => {
        setIsLoading(true)
        const today = formatDateToUTCStringDate(new Date())
        const createParam = {
            issueData:[{
                articleUrl: search.get('url'),
                content: currentExecuteRow.tableItem.content,
                exceptionType: exceptionType,
                sourceApp: 'CHIRON',
                reporter: userAccount.username,
                reportTime: today,
                riskArea: 'BrokenLink',
                businessJustification: businessJustificationValue,
                startTime: today,
                expireTime: formatDateToUTCStringDate(new Date(expirationDate)),
            }]
        }
        try {
            const data = await apiService.createIssueReport(createParam);
            if(data.success) {
                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Successfully reported!'
                })
                setTimeout(()=>{
                    dismissAlert()
                }, 3000)
                setShowReport(false)
                getReportedBrokenLink()
            }
        }catch(error){
            setMessageState({
                messageType: 'error',
                showMessage: true,
                message: `Report failed, detail:${error.errorMessage ? error.errorMessage: 'Unknown error, please try again later!'}`,
                onDismiss: dismissAlert
            })
        }finally {
            setIsLoading(false)
        }
    }

    const getReportedBrokenLink = () => {
        setIsLoading(true)
        const requestUrl = search.get('url')
        const orgList = [...issueList]
        apiService.getIssueList(requestUrl, userAccount.username, issueList, 'BrokenLink').then(res => {
            res.issueData.forEach(issue => {
                orgList.forEach(item => {
                    if(item.content === issue.content && issue.issueId ) {
                        item.status = `Reported as ${issue.exceptionType}`
                    }
                })
            })
            setTableItems(orgList)
            setIsLoading(false)
        })
    }

    /**
     * build data list columns
     * @returns 
     */
    // function buildColumns(): any {
    //     const columns = [
    //         {
    //             id: "content",
    //             name: "Link",
    //             maxWidth: 1000,
    //             readonly: true,
    //             renderCell: renderChildLinkColumn,
    //             sortProps: {
    //                 ariaLabelAscending: "Sorted low to high",
    //                 ariaLabelDescending: "Sorted high to low",
    //             },
    //             width: new ObservableValue(-1000),
    //         },
    //         {
    //             id: "context",
    //             name: "Link text",
    //             maxWidth: 500,
    //             readonly: true,
    //             renderCell: renderSimpleCell,
    //             sortProps: {
    //                 ariaLabelAscending: "Sorted low to high",
    //                 ariaLabelDescending: "Sorted high to low",
    //             },
    //             width: new ObservableValue(-500),
    //         },
    //         {
    //             id: "status",
    //             name: "Status",
    //             maxWidth: 300,
    //             readonly: true,
    //             renderCell: renderSimpleCell,
    //             sortProps: {
    //                 ariaLabelAscending: "Sorted low to high",
    //                 ariaLabelDescending: "Sorted high to low",
    //             },
    //             width: new ObservableValue(-300),
    //         },
    //         {
    //             id: "actions",
    //             name: "Actions",
    //             maxWidth: 300,
    //             readonly: true,
    //             renderCell: renderButtonCell,
    //             width: new ObservableValue(-300),
    //         }

    //     ];

    //     return columns;
    // }

    // const buildTableItems = () => {
    //     return new ArrayItemProvider<IListItem>(
    //         tableItems.map(item => {
    //             return {
    //                 content: item.content,
    //                 context: item.context,
    //                 status: item.status
    //             }
    //          })
    //     )
    // }

    const buttonClick = (type: string, currentRow: {tableItem: IListItem, rowIndex: number}) => {
        setReportType(type)
        setShowReport(true)
        setCurrentExecuteRow(currentRow)
        setReportDetailCss('report-detail-form-in')
    }

    // function renderButtonCell(
    //     rowIndex: number,
    //     columnIndex: number,
    //     tableColumn: ITableColumn<IListItem>,
    //     tableItem: IListItem) {
    //         const menuProps: IContextualMenuProps = {
    //             onItemClick(ev, item) {
    //                 buttonClick(item.key,{tableItem,rowIndex})
    //             },
    //             items: [
    //                 {
    //                     key: 'falsePositive',
    //                     text: 'Report as false positive'
    //                 },
    //                 {
    //                     key: 'exception',
    //                     text: 'Set an exception'
    //                 },
    //             ]
    //         }
    //         return (
    //             <SimpleTableCell
    //                 columnIndex={columnIndex}
    //                 tableColumn={tableColumn}
    //                 key={tableColumn.id}
    //                 contentClassName="bolt-table-cell-content-with-inline-link no-v-padding"
    //                 >
    //                     {
    //                         tableItem.status === 'Broken' &&
    //                         <CommandButton iconProps={{iconName: 'Add'}} text="New action" menuProps={menuProps}/>
    //                     }
    //             </SimpleTableCell>
    //         )
    // }

    /**
   * Render ContentId cell
   * @param rowIndex 
   * @param columnIndex 
   * @param tableColumn 
   * @param tableItem 
   * @returns 
   */
    // function renderChildLinkColumn(
    //     rowIndex: number,
    //     columnIndex: number,
    //     tableColumn: ITableColumn<IListItem>,
    //     tableItem: IListItem) {
    //     const { content } = tableItem

    //     return (
    //         <SimpleTableCell
    //             columnIndex={columnIndex}
    //             tableColumn={tableColumn}
    //             key={"col-" + columnIndex}
    //             contentClassName="bolt-table-cell-content-with-inline-link no-v-padding"
    //         >
    //             {
    //                 content && content.toString() !== '' ?
    //                     (
    //                         <Link
    //                             className="fontSizeM font-size-m text-ellipsis bolt-table-link bolt-table-inline-link"
    //                             excludeTabStop
    //                             href={content}
    //                             target={"_blank"}
    //                         >
    //                             {content}
    //                         </Link>
    //                     )
    //                     :
    //                     (
    //                         <div className="flex-row scroll-hidden">
    //                             {content}
    //                         </div>
    //                     )
    //             }

    //         </SimpleTableCell>
    //     );
    // }


    return (
        <div style={{ width: "100%" }}>
            {/* <div className="flex-grow">
                <br />
            </div> */}

            <div style={{ width: '50%', position: 'relative', marginLeft: "5%" }}>
                <CustomMessageAlert
                    type={messageState.messageType}
                    message={messageState.message}
                    showAlert={messageState.showMessage}
                    onDismiss={messageState.onDismiss}
                />
            </div>

            <div className="ms-Grid-row" style={{ width: "100%" }}>
                <div className="ms-Grid-col ms-sm8 ms-md3 ms-lg8 msacct-content" style={{ border: "0px", overflowY: "scroll" }}>

                    <Stack tokens={{ childrenGap: 8 }} className="customCard" style={{ padding: "16px 5px 0px 16px" }}>
                        <div style={{ flexWrap: "wrap", maxHeight: "90vh",overflowWrap: 'break-word' }}>

                            {/* <Button
                                text="Visit site" iconProps={{ iconName: "PreviewLink" }} 
                                className='floatBtu' subtle={true}
                                onClick={() => {
                                    window.location.href = requesturl;
                                }}
                            /> */}
                            <DefaultButton
                                text="Visit site" iconProps={{ iconName: "PreviewLink" }}
                                className='floatBtu' onClick={() => {
                                    window.location.href = requesturl;
                                }} style={{ zIndex: "9" }}
                            />

                            <div className="page-content page-content-top" style={{ paddingLeft: "5px", paddingRight: "5px" }}>

                                {/* <div style={{ width: "185px", backgroundColor: "#efefef", textAlign: "center", padding: "5px", borderRadius: "8px", marginBottom: "10px" }}>
                                    <Button
                                        text="Preview" style={{ backgroundColor: buttonStyle ? "#ffffff00" : "#fff", borderRadius: "7px", height: "28px" }}
                                        onClick={() => {
                                            setButtonStyle(false);
                                        }}
                                    />
                                    <Button
                                        text="Metadata" style={{ backgroundColor: buttonStyle ? "#fff" : "#ffffff00", marginLeft: "5px", borderRadius: "7px", height: "28px" }}
                                        onClick={() => {
                                            setButtonStyle(true);
                                        }}
                                    />
                                </div> */}

                                <ArticleDiff previousDraft={newDiffEditorData} newDraft={newNavigationDiffEditorData} />

                                <div className="flex-grow">
                                    <br />
                                </div>

                            </div>
                        </div>

                    </Stack>

                </div>
                <div className="ms-Grid-col ms-sm4 ms-md9 ms-lg4 msacct-content" style={{ border: "0px" }}>
                    {/* <ContentMarkerRight id={requestid} originalIssueList={issueList} title='Content Issues' /> */}

                    <div className="ms-Grid-row">
                        <Stack tokens={{ childrenGap: 8 }} className="customCard">
                            <div className="flex-row approveOpption" style={{ flexWrap: "wrap" }}>
                                <div><h3 className='rightTitle'>Action required</h3></div>
                                <div className="flex-column" style={{ width: "100%", wordWrap: "break-word" }}>
                                    <p>
                                        Please make sure that your article's information is accurate. Once you click one of the buttons below and take the necessary
                                        actions, your article will be renewed for another <span style={{ color: "red" }}>{props.reviewContentMarker?.TicketInfo?.RenewDays} days</span>.
                                    </p>
                                    <p>
                                        If no action is taken by&nbsp;
                                        <span className='fontWeight'>
                                            {
                                                props.reviewContentMarker?.TicketInfo?.DueDatePstFormat
                                            }
                                        </span>
                                        , this article will be archived, along with all associated images, and referenced
                                        files. Select one of the buttons below to mark this article as reviewed, improve this article or archive this article.
                                    </p>

                                </div>
                                <div>
                                    <Checkbox
                                        onChange={(event, checked) => {
                                            setCheckbox(checked);
                                            // setRadioGroupValue(radioGroupValue == null ? "0" : radioGroupValue);
                                        }}
                                        checked={checkbox}
                                        className='customCheckbox'
                                        onRenderLabel={() => (
                                            <span>
                                                As an accountable owner of this article, by clicking on <span className='fontWeight'>Mark as reviewed</span>. I am aware that the article will be
                                                renewed for another {props.reviewContentMarker?.TicketInfo?.RenewDays} days. By clicking on <span className='fontWeight'>Improve this article</span>. I confirm that I will taken all the actions
                                                to ensure that the article is update to date. By clicking on <span className='fontWeight'>Archive this article</span>. I confirm that I will taken
                                                all the actions to ensure that the article is archived.
                                            </span>
                                        )}
                                    />
                                </div>
                                {/* <div className='button-top'>
                                    <Button text="Mark as reviewed" disabled={!checkbox} iconProps={{ iconName: "CheckMark" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                        clickMakeasReviewed();
                                    }} />
                                </div>
                                <div className='button-top'>
                                    <Button text="Improve this article" disabled={!checkbox} iconProps={{ iconName: "Edit" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                        clickImproveArticle();
                                    }} />
                                </div>
                                <div className='button-top'>
                                    <Button text="Archive this article" disabled={!checkbox} iconProps={{ iconName: "FolderHorizontal" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                        clickArchiveArticle();
                                    }} />
                                </div> */}
                                <div className='button-top'>
                                    <PrimaryButton text="Mark as reviewed" disabled={!checkbox} iconProps={{ iconName: "CheckMark" }}
                                        primary={true} style={{ width: "55%" }} onClick={() => {
                                            clickMakeasReviewed(false);
                                        }} />
                                </div>
                                <div className='button-top'>
                                    <PrimaryButton text="Improve this article" disabled={!checkbox} iconProps={{ iconName: "Edit" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                        clickImproveArticle();
                                    }} />
                                </div>
                                <div className='button-top'>
                                    <PrimaryButton text="Archive this article" disabled={!checkbox} iconProps={{ iconName: "FolderHorizontal" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                        clickArchiveArticle();
                                    }} />
                                </div>

                                <div style={{ marginBottom: "20px" }}>
                                    {/* <p>
                                        If you need to report a false positive case or request an exception,please click on
                                        <div></div>
                                        <Button text="Submit exceptions/false positive cases"
                                            style={{ borderRadius: "20px", height: "22px", marginTop: "5px" }}
                                            primary={true} onClick={() => {
                                                setIsDialogOpen(true)
                                            }} />
                                    </p> */}
                                    <p>
                                        If you have any questions about <a href="https://aka.ms/ACCTUserGuide">Sonic</a>, <a href="https://aka.ms/Autohealing">Chiron</a>, or the proposed change above, please click <a href="https://aka.ms/ChironSupport">here</a> to create a ticket for assistance.
                                    </p>
                                </div>
                            </div>
                        </Stack>
                    </div>

                    {/* <div>
                        {
                            isDialogOpen ? (
                                <Dialog
                                    titleProps={{ text: "Content Issues" }}
                                    footerButtonProps={[
                                        {
                                            text: "Close",
                                            onClick: onDismiss
                                        }
                                    ]}
                                    onDismiss={onDismiss}
                                    calloutContentClassName='issue-center-dialog'
                                >
                                    
                                </Dialog>
                            ) : null
                        }
                    </div> */}

                    {/* <div>
                        {
                            isDialogOpen ? (
                                <Dialog
                                    titleProps={{ text: "Content Issues" }}
                                    footerButtonProps={[
                                        {
                                            text: "Close",
                                            onClick: onDismiss
                                        }
                                    ]}
                                    onDismiss={onDismiss}
                                    calloutContentClassName='issue-center-dialog'
                                >
                                    {
                                        showReport ?
                                            <Card className={reportDetailCss}>
                                                <div style={{ width: '100%' }}>
                                                    <ExceptionReportDialog
                                                        showReportExceptionDialog={showReport}
                                                        dismissReportDialog={dismissReportDetail}
                                                        onSubmit={submitReportDetail}
                                                        reportType={reportType}
                                                    />
                                                </div>
                                            </Card> :
                                            <Card className="flex-grow bolt-table-card report-detail-list" contentProps={{ contentPadding: false }}>
                                                <Table
                                                    ariaLabel="Basic Table"
                                                    columns={buildColumns()}
                                                    itemProvider={buildTableItems()}
                                                    role="table"
                                                    className="issue-center-table"
                                                    containerClassName="h-scroll-auto"
                                                />
                                            </Card>
                                    }
                                </Dialog>
                            ) : null
                        }
                    </div> */}

                    {/* <div className="ms-Grid-row" style={{ marginTop: "20px", display: "none" }}>
                        <Card className="flex-grow approveOpption"
                            collapsible={true}
                            collapsed={collapsedTicket}
                            onCollapseClick={onCollapseTicketClicked}
                            titleProps={{
                                text: "AI Recommendations",
                                ariaLevel: 3,
                            }}>
                            <div className="flex-row approveOpption" style={{ flexWrap: "wrap", marginBottom: "30px" }}>
                                <div className="flex-column" style={{ width: "100%", wordWrap: "break-word", marginLeft: "20px" }}>
                                    Update to reflect latest version of product
                                </div>
                                <div style={{ marginLeft: "25px" }}>
                                    <div><h3>Improved Text:</h3></div>
                                    <div style={{ padding: "10px", backgroundColor: '#efefef', borderRadius: '5px' }}>
                                        Windows Updates released on or after 9.2024 changed the....
                                    </div>

                                    <div><h3>Reason for the changes:</h3></div>
                                    <div style={{ marginLeft: "20px" }}>
                                        1.Changed "7B.24 July 9" to "7B.28 July 9" for clarity...
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div> */}

                </div>
            </div>

            {
                isLoading && <Spinner className='autohealing-loading' label='Loading...' size={SpinnerSize.large} />
            }

            {
                isSubmitting && <Spinner className='autohealing-loading' label='Submitting...' size={SpinnerSize.large} />
            }

        </div>
    )
}

export default connect<StoreProps, DispatchProps>(
    mapStateToProps,
    bindActionCreators.bind({}, actionCreators)
)(ArchivingContentMarker);
